import { useSyncExternalStore } from 'react';

import {
  getThemePreference,
  resolveTheme,
  setThemePreference,
  subscribeThemePreference,
  type ResolvedTheme,
  type ThemePreference,
} from './themePreference';

export function useThemePreference(): {
  preference: ThemePreference;
  resolvedTheme: ResolvedTheme;
  setPreference: (preference: ThemePreference) => void;
} {
  const preference = useSyncExternalStore(
    subscribeThemePreference,
    getThemePreference,
    getThemePreference,
  );
  return {
    preference,
    resolvedTheme: resolveTheme(preference),
    setPreference: setThemePreference,
  };
}
